<template>
     <div style="width: 100%" v-if="regs.length > 0">
      <BarChart :chart-data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'
import Chart from 'chart.js'

import BarChart from '@/components/charts/BarChart.vue'

export default {
  name: 'regChart',
  components: {
    BarChart
  },
  props: {
    regs: Array,
  },
  data() {
    return {
      canvas: null,
      chart: null
    }
  },
  computed: {
    labels() {
      return _.uniq(_.flatMap(this.regs, 'date'));
    },
    approvedData() {
      const approvedTime = _(this.regs)
              .groupBy('date')
              .map((v, k) => ({
                date: moment(k),
                sum: (_.sumBy(v, function(o) {
                  if(o.isApproved == true) {
                    return o.time
                  } else {
                    return 0
                  }
                })),
              })).value();
      return _.map(approvedTime, 'sum');
    },
    notApprovedData() {
      const notApprovedTime = _(this.regs)
        .groupBy('date')
        .map((v, k) => ({
          date: moment(k),
          sum: (_.sumBy(v, function(o) {
            if(o.isApproved == false || !o.isApproved) {
              return o.time
            } else {
              return 0
            }
          })),
        })).value();
      return _.map(notApprovedTime, 'sum');  
    },
    chartData() {
      return {
        labels: this.labels,
              datasets: [
                {
                  label: this.$i18n.t("chart.approved"),
                  backgroundColor: 'rgb(0, 209, 178)',
                  borderColor: 'rgb(0, 209, 178)',
                  data: this.approvedData
                },
                {
                  label: this.$i18n.t("chart.notApproved"),
                  backgroundColor: 'rgb(255, 99, 132)',
                  borderColor: 'rgb(255, 99, 132)',
                  data: this.notApprovedData
                },
              ]
      }
    },
    chartOptions() {
      return {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              xAxes: [{
                type: 'time',
                stacked: true,
                time: {
                    unit: 'day',
                    displayFormats: {
                        day: 'DD/MM'
                    },
                    isoWeekday: true,
                },
                ticks: {
                  // callback: function(value, index, values) {
                  //   if(moment(value).isoWeekday() == 1) {
                  //     return moment(value).format("DD/MM/YY");
                  //   } else {
                  //     return ;
                  //   }
                  // }
                }
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                    beginAtZero:true
                }
              }]
          }
      }
    }
  },
  mounted() {
      moment.locale(this.$i18n.locale);
    }
}
</script>

<style>

</style>
